import { View } from 'react-native';
import type { ViewProps } from 'react-native';

import { styles } from './styles';

const HorizontalSeparator = ({ style, ...props }: ViewProps) => {
  return <View {...props} style={[styles.separator, style]} />;
};

HorizontalSeparator.displayName = 'HorizontalSeparator';
export { HorizontalSeparator };
